<div class="dialog-header">
  <span class="dialog-header__title">Ergebnisse filtern</span>

  <button mat-button class="dialog-header__clear-all-button" color="accent" (click)="filterReset.emit()">
    Zurücksetzen <mat-icon>close</mat-icon>
  </button>

  <button mat-icon-button class="dialog-header__close-button" (click)="closed.emit()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="dialog-content">
  <ng-content />
</div>

<div class="dialog-footer">
  <button mat-button color="accent" (click)="closed.emit()">Schließen</button>
  <button mat-flat-button class="dialog-footer__confirm-button" color="accent" (click)="saved.emit()">
    Filter speichern
  </button>
</div>
